module.exports = __webpack_public_path__ + "img/Seagull_Logo.30cd6aac.png";